// extracted by mini-css-extract-plugin
module.exports = {"studyPlanSettingsForm":"style-module__studyPlanSettingsForm___3eYOu","cancelButton":"style-module__cancelButton___1IpH8"};